import { HOST_TOOL_NAMES } from "../../turns/turn-constants";
import { labelOnly } from "../label-only";
import type { ToolActivity } from "../tool-activity";
import type { ToolActivityState } from "../tool-activity-state";

export const shaderToolActivityDescribers: readonly [
  string,
  (record: Record<string, unknown>, state: ToolActivityState) => ToolActivity,
][] = [
  [HOST_TOOL_NAMES.SHADER_LIST, () => labelOnly("Listed the shaders")],
  [HOST_TOOL_NAMES.SHADER_CREATE, () => labelOnly("Created a shader")],
  [HOST_TOOL_NAMES.SHADER_READ, () => labelOnly("Read the shader")],
  [
    HOST_TOOL_NAMES.SHADER_PUBLISH,
    () => labelOnly("Published a shader version"),
  ],
];
